import { RouteRecordRaw } from "vue-router";
import Login from "@/main/pages/Login.vue";
import LoginPicker from "@/main/pages/LoginPicker.vue";
import SignUp from "@/main/pages/SignUp.vue";
import { Routes } from "./types/enums/routes.enum";
import Dashboard from "./pages/Dashboard.vue";
import frontLayoutVue from "./layouts/front-layout.vue";
import SettingsVue from "./pages/Settings.vue";
import CustomersVue from "./pages/Customers.vue";
import Schedules from "./pages/Schedules.vue";
import CompanyBookingPage from "./pages/booking/CompanyBookingPage.vue";
import GuestAccountPage from "./pages/booking/GuestAccountPage.vue";
import VerifyEmailPage from "./pages/booking/VerifyEmailPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: Routes.Main,
    component: LoginPicker,
  },
  {
    path: Routes.Login,
    component: Login,
  },
  {
    path: Routes.SignUp,
    component: SignUp,
  },
  {
    path: Routes.Admin,
    component: frontLayoutVue,
    children: [
      {
        path: "",
        component: Dashboard,
      },
      {
        // Child paths must stay relative (no leading "/") so they nest
        // under Routes.Admin ("/ad/") instead of vue-router treating a
        // leading-slash path as absolute and matching it at the root -
        // which is what silently produced bare "/customers" etc. before,
        // bypassing the auth guard in router.plugin.ts (which only checks
        // paths starting with "/ad/") and the push-permission check in
        // App.vue for every admin page except the dashboard itself.
        path: "customers",
        component: CustomersVue,
      },
      {
        path: "schedule",
        component: Schedules,
      },
      {
        path: "settings",
        component: SettingsVue,
      },
      {
        path: "checkout",
        component: () => import("./pages/Checkout.vue"),
      }
    ],
  },
  {
    path: Routes.PublicBooking,
    component: CompanyBookingPage,
  },
  {
    path: Routes.GuestAccount,
    component: GuestAccountPage,
  },
  {
    path: Routes.VerifyEmail,
    component: VerifyEmailPage,
  },
];

export default routes;
